export default __webpack_public_path__ + "static/media/Tetris.01ac8e9b.png";